import { getSVG } from '@/components/Common/styles/mixins';
import { GlobalStoreCtx, ISmartBanner } from '@/stores/GlobalStore';
import { redirectTo } from '@/utils';
import { observer } from 'mobx-react-lite';
import qs from 'qs';
import React, { useCallback, useContext } from 'react';

import styles from './DeepLinkBanner.module.scss';
import Cookies from 'js-cookie';

const makeDeepLinkNew = (smartBanner: ISmartBanner): string => {
  if (!smartBanner?.path) {
    console.error('Invalid smartBanner or smartBanner.path');
    return '';
  }
  // 딥링크에 추가할 쿼리 파라미터
  const queryParamsForDeepLink = qs.stringify(
    {
      ...smartBanner.params,
      via: 'mweb',
      viaCgntId: Cookies.get('cgntId') || undefined,
      trackcode: Cookies.get('trackcode') || undefined,
    },
    { addQueryPrefix: true, skipNulls: true },
  );

  // 앱 딥링크 스킴
  const appDeepLink = `yanoljamotel://${smartBanner.path}${queryParamsForDeepLink}`;

  // onelink로 전달할 최종 URL 파라미터 생성
  const finalUrlParams = qs.stringify(
    {
      pid: 'smartbanner', // 캠페인 식별자
      af_click_lookback: '1d', // 클릭 후 리타게팅 가능 기간
      is_retargeting: 'true', // 리타게팅 여부
      af_reengagement_window: '30d', // 리타게팅 기간 설정
      af_force_deeplink: 'true', // 앱 강제 실행 옵션
      af_dp: appDeepLink, // 딥링크 주소
      deep_link_value: appDeepLink, // 백업 딥링크 값
    },
    { addQueryPrefix: true, skipNulls: true },
  );

  // 최종 생성된 딥링크 URL 반환
  return `https://yanolja.onelink.me/tmFm${finalUrlParams}`;
};

const DeepLinkBanner: React.FC<{ imagePath: string }> = ({ imagePath }) => {
  const globalStore = useContext(GlobalStoreCtx);

  const openDeepLink = useCallback(() => {
    const deepLink = makeDeepLinkNew(globalStore.SmartBanner!);

    redirectTo(deepLink, globalStore.Device);
  }, [globalStore.SmartBanner]);

  return (
    globalStore.SmartBanner && (
      <section className={styles.container} onClick={openDeepLink}>
        <img className={styles.image} src={getSVG(imagePath)} />
        <button className={styles.action}>
          <span>앱에서 보기</span>
          <i />
        </button>
      </section>
    )
  );
};

export default observer(DeepLinkBanner);
